import { Storage } from '~/shared/utils/storage/storage';
import { useLocalStorageString } from '../utils';

export default function usePostalCode() {
    return useLocalStorageString(Storage.postalCode, undefined);
}
